import { render, staticRenderFns } from "./CustomerMealRecommendations.vue?vue&type=template&id=fff37c4c&scoped=true"
import script from "./CustomerMealRecommendations.vue?vue&type=script&lang=js"
export * from "./CustomerMealRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff37c4c",
  null
  
)

export default component.exports